var moment = require("moment");
moment.tz = require("moment-timezone");
function thousandSeparator(nStr) {
  nStr += "";
  var x = nStr.split(",");
  var x1 = x[0];
  var x2 = x.length > 1 ? "," + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "." + "$2");
  }
  return x1 + x2;
}

function convertDate(tanggal) {
  return moment.utc(tanggal).format("D MMM YYYY HH:mm");
}

function dateID(tanggal) {
  return moment(tanggal)
    .locale("id")
    .format("D MMM YYYY");
}

function dateTimeID(tanggal) {
  return moment.utc(tanggal).format("D MMM YYYY HH:mm");
}

function timestampTodate(tanggal) {
  return moment.utc(tanggal).format("YYYY-MM-DD");
}

function date(tanggal) {
  return moment
    .utc(tanggal)
    .tz("Asia/Jakarta")
    .locale("id");
}

function dateIndonesia(tanggal) { 
  return moment
  .utc(tanggal)
  .tz("Asia/Jakarta")
  .locale("id").format("D MMM YYYY HH:mm");
 }

function getDateTujuhHariTerakhir(format) {
  var start = moment()
    .subtract(6, "days")
    .locale("id")
    .format(format);
  var end = moment()
    .locale("id")
    .format(format);
  let date = [];
  date["from"] = start;
  date["to"] = end;
  return date;
}

function getDateTujuhHariTerakhirDefault() {
  var start = moment()
    .subtract(6, "days")
    .locale("id")
    .format("YYYY-MM-DD 00:00:00");
  var end = moment()
    .locale("id")
    .format("YYYY-MM-DD 23:59:59");
  let date = [];
  date["from"] = start;
  date["to"] = end;
  return date;
}

function kmbFormatter(num) {
  let kmb;
  if (Math.abs(num) > 999999) {
    kmb = Math.sign(num) * (Math.abs(num) / 1000000).toFixed(1);
    kmb = thousandSeparator(kmb.toString().replace(".", ","));
    kmb = thousandSeparator(kmb) + "m";
  } else if (Math.abs(num) > 999) {
    kmb = Math.sign(num) * (Math.abs(num) / 1000).toFixed(1);
    kmb = thousandSeparator(kmb.toString().replace(".", ","));
    kmb = thousandSeparator(kmb) + "k";
  } else {
    kmb = Math.sign(num) * Math.abs(num);
    if (kmb % 1 != 0) {
      kmb = kmb.toFixed(2);
    }
  }
  return kmb;
}

function limitString(text, count){
  return text.slice(0, count) + (text.length > count ? "..." : "");
}

function extractPhrase(strData) {
  // const objPattern = new RegExp(
  //   '(\\,|\\r?\\n|\\r|^)(?:"([^"]*(?:""[^"]*)*)"|([^\\,\\r\\n]*))',
  //   "gi"
  // );
  // let arrMatches = null,
  //   arrData = [[]];
  // while ((arrMatches = objPattern.exec(strData))) {
  //   if (arrMatches[1].length && arrMatches[1] !== ",") arrData.push([]);
  //   arrData[arrData.length - 1].push(
  //     arrMatches[2]
  //       ? arrMatches[2].replace(new RegExp('""', "g"), '"')
  //       : arrMatches[3]
  //   );
  // }
  let arrData = strData.match(/\w+|"[^"]+"/g)
  arrData = arrData.map(item => {
    if (item.includes('"')) {
      return item.replace(/"/g, '')
    } else {
      return item
    }
  })
  return arrData;
}

export default {
  thousandSeparator,
  date,
  dateID,
  dateTimeID,
  getDateTujuhHariTerakhir,
  getDateTujuhHariTerakhirDefault,
  kmbFormatter,
  convertDate,
  extractPhrase,
  limitString,
  timestampTodate,
  dateIndonesia
};
